import { Default, Detail,  List, Create } from "./views";

const Module = {
    name: "proposals",
    defaultRoutePath: "/opportunities/proposal",
    menuItemScope: "operations",
    menuItemName: "proposal",

    routes: [
        {
            path: "/opportunities/proposal",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
